import { lazy } from 'react';
import ErrorLayout from '../layout/ErrorLayout';
import Loadable from '../ui-component/Loadable';

const ErrorPage = Loadable(lazy(() => import('../views/pages/ErrorPages/404')));
const NotAuthorizedPage = Loadable(lazy(() => import('../views/pages/ErrorPages/NotAuthorized')));

const ErrorRoutes = {
    path: '/',
    element: <ErrorLayout />,
    children: [
        {
            path: '/404',
            element: <ErrorPage />
        },
        {
            path: '/not-authorized',
            element: <NotAuthorizedPage />
        },
        {
            path: "*",
            element: <ErrorPage />
        }
    ]
};

export default ErrorRoutes;